import { Instagram, Music2, ArrowUpRight } from "lucide-react";
import { ScrollReveal } from "./Reveal";

const CHANNELS = [
  {
    icon: Instagram,
    platform: "Instagram",
    handle: "@sora.japaneseschool",
    url: "https://www.instagram.com/sora.japaneseschool",
    text: "Atmosfera de la ore, ateliere de caligrafie și cultură japoneză, zi de zi.",
    testid: "instagram-social-link",
  },
  {
    icon: Music2,
    platform: "TikTok",
    handle: "@sorajapaneseschoo",
    url: "https://www.tiktok.com/@sorajapaneseschoo",
    text: "Clipuri scurte: cuvântul zilei, kanji explicate și momente din clasă.",
    testid: "tiktok-social-link",
  },
];

export default function Social() {
  return (
    <section id="comunitate" data-testid="social-section" className="relative py-20 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <ScrollReveal>
              <p className="text-xs font-mono tracking-[0.3em] uppercase text-hanko mb-4">Comunitatea SORA</p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-sumi leading-tight">
                Povestea continuă <span className="italic text-hanko">în feed.</span>
              </h2>
              <p className="mt-6 text-charcoal/80 leading-relaxed max-w-md">
                Majoritatea elevilor ne descoperă pe TikTok și Instagram. Hai să ne cunoști înainte
                de prima lecție — exact așa arată o seară la SORA.
              </p>
            </ScrollReveal>

            <div className="mt-10 space-y-4">
              {CHANNELS.map((c, i) => {
                const Icon = c.icon;
                return (
                  <ScrollReveal key={c.platform} delay={0.1 + i * 0.1}>
                    <a
                      href={c.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={c.testid}
                      className="group flex items-center gap-5 bg-white border border-sumi/10 p-5 sm:p-6 transition-all duration-500 hover:-translate-y-1 hover:border-hanko/50 hover:shadow-[0_20px_50px_-20px_rgba(211,47,47,0.25)]"
                    >
                      <span className="w-12 h-12 rounded-full bg-sumi flex items-center justify-center shrink-0 transition-colors duration-500 group-hover:bg-hanko">
                        <Icon size={22} className="text-washi" />
                      </span>
                      <span className="flex-1 min-w-0">
                        <span className="block text-[11px] font-mono tracking-widest uppercase text-charcoal/50">{c.platform}</span>
                        <span className="block font-semibold text-sumi truncate">{c.handle}</span>
                        <span className="block text-sm text-charcoal/65 mt-1">{c.text}</span>
                      </span>
                      <ArrowUpRight size={20} className="text-charcoal/40 transition-all duration-300 group-hover:text-hanko group-hover:translate-x-1 group-hover:-translate-y-1 shrink-0" />
                    </a>
                  </ScrollReveal>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <ScrollReveal delay={0.15}>
              <div className="relative">
                <div className="grid grid-cols-2 gap-4 sm:gap-6">
                  <img
                    src="https://images.unsplash.com/photo-1736086599483-b37b45cc44cc?crop=entropy&cs=srgb&fm=jpg&q=85"
                    alt="Stradă în Tokyo, noaptea"
                    loading="lazy"
                    className="w-full aspect-[3/4] object-cover mt-10"
                    data-testid="social-image-street"
                  />
                  <img
                    src="https://images.unsplash.com/photo-1583868635757-b417c771a41e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                    alt="Caractere japoneze caligrafiate"
                    loading="lazy"
                    className="w-full aspect-[3/4] object-cover"
                    data-testid="social-image-kanji"
                  />
                </div>
                <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-hanko text-washi font-jp px-6 py-3 text-lg rounded-[12px] shadow-lg shadow-hanko/30 whitespace-nowrap">
                  フォローしてね · urmărește-ne
                </span>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}
